import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from "@/lib/utils";

interface DashboardHeaderProps {
  className?: string;
}

export function DashboardHeader({ className }: DashboardHeaderProps) {
  useLanguage();
  return (
    <div
      className={cn(
        "h-11 bg-gradient-to-b from-gray-50 to-gray-100/80 flex items-center justify-between px-4 border-b border-gray-200/60",
        className
      )}
    >
      {/* Traffic lights - Neutral tones */}
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 rounded-full bg-gray-300 shadow-sm" />
        <div className="w-3 h-3 rounded-full bg-gray-300 shadow-sm" />
        <div className="w-3 h-3 rounded-full bg-[#1F6BFF]/40 shadow-sm" />
        <span className="ml-3 text-[11px] text-gray-500 font-medium tracking-wide">
          {translateInterfaceText("HostVSL Dashboard")}</span>
      </div>

      {/* Online badge - Blue monochromatic */}
      <div className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-[#1F6BFF]/5 border border-[#1F6BFF]/20">
        <div className="relative">
          <div className="w-1.5 h-1.5 rounded-full bg-[#1F6BFF]" />
          <div className="absolute inset-0 w-1.5 h-1.5 rounded-full bg-[#1F6BFF] animate-ping opacity-75" />
        </div>
        <span className="text-[10px] font-medium text-[#1F6BFF]">{translateInterfaceText("Online")}</span>
      </div>
    </div>
  );
}
